import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Directive, HostBinding, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';

import { SnDrawerService } from '../services';

@Directive({
  selector: '[snDrawerAppContent]',
  host: {
    class: 'sn-drawer-app-content',
  },
})
export class SnDrawerAppContentDirective implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _drawer: SnDrawerService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {}

  @HostBinding('style.margin-left.px')
  get marginLeft(): number {
    return this._drawer.drawerAppContentMargins.left;
  }

  @HostBinding('style.margin-right.px')
  get marginRight(): number {
    return this._drawer.drawerAppContentMargins.right;
  }

  public ngOnInit(): void {
    this._drawer.appContentMarginChange$.pipe(takeUntil(this._destroy$)).subscribe(() => {
      this._changeDetectorRef.markForCheck();
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
